import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrash } from "@fortawesome/free-solid-svg-icons";
import styles from "./DeleteConfirmModal.module.css";
import { useLanguage } from "../../../../context/LanguageContext";

interface DeleteConfirmModalProps {
  isOpen: boolean;
  onConfirm: () => void;
  onCancel: () => void;
  title?: string;
  message?: string;
  fieldName?: string;
}

export default function DeleteConfirmModal({
  isOpen,
  onConfirm,
  onCancel,
  title,
  message,
  fieldName,
}: DeleteConfirmModalProps) {
  const { t } = useLanguage();

  if (!isOpen) return null;

  return (
    <div className={styles.modalOverlay} onClick={onCancel}>
      <div className={styles.modalContent} onClick={(e) => e.stopPropagation()}>
        <div className={styles.modalIcon}>
          <FontAwesomeIcon icon={faTrash} />
        </div>
        <h3 className={styles.modalTitle}>
          {title || t("confirmDeleteField")}
        </h3>
        {fieldName && (
          <p className={styles.modalFieldName}>
            <strong>{fieldName}</strong>
          </p>
        )}
        <p className={styles.modalMessage}>
          {message || t("confirmDeleteFieldMessage")}
        </p>
        <div className={styles.modalButtons}>
          <button onClick={onConfirm} className={styles.modalDeleteBtn}>
            <FontAwesomeIcon icon={faTrash} />
            {t("delete")}
          </button>
          <button onClick={onCancel} className={styles.modalCancelBtn}>
            {t("cancel")}
          </button>
        </div>
      </div>
    </div>
  );
} 